import WeatherBox from '../../components/boxs/weather/WeatherBox';
import RoomTemperatureBox from '../../components/boxs/room-temperature/RoomTemperature';
import RoomHumidityBox from '../../components/boxs/room-humidity/RoomHumidity';
import CameraBox from '../../components/boxs/camera/Camera';
import AtHomeBox from '../../components/boxs/user-presence/UserPresence';
import DevicesInRoomsBox from '../../components/boxs/device-in-room/DevicesInRoomsBox';
import DevicesBox from '../../components/boxs/device-in-room/DevicesBox';
import ChartBox from '../../components/boxs/chart/Chart';
import EcowattBox from '../../components/boxs/ecowatt/Ecowatt';
import ClockBox from '../../components/boxs/clock/Clock';
import SceneBox from '../../components/boxs/scene/SceneBox';
import AlarmBox from '../../components/boxs/alarm/Alarm';
import MusicBox from '../../components/boxs/music/MusicBox';
import EdfTempoBox from '../../components/boxs/edf-tempo/EdfTempo';
import GaugeBox from '../../components/boxs/gauge/GaugeBox';
import EnergyConsumptionBox from '../../components/boxs/energy-consumption/EnergyConsumption';
import EnergyPriceBox from '../../components/boxs/energy-price/EnergyPrice';
import VoiceAssistantBox from '../../components/boxs/voice-assistant/VoiceAssistantBox';
import LinkBox from '../../components/boxs/link/LinkBox';
import PhotoBox from '../../components/boxs/photo/PhotoBox';
import SunBox from '../../components/boxs/sun/Sun';
import ChipsBox from '../../components/boxs/chips/ChipsBox';
import ActionsBox from '../../components/boxs/actions/ActionsBox';
import HouseViewBox from '../../components/boxs/house-view/HouseViewBox';
import ExternalWidgetBox from '../../components/boxs/external-widget/ExternalWidgetBox';
import ErrorBoundary from '../../components/ErrorBoundary';
import ThermostatBox from '../../components/boxs/thermostat/ThermostatBox';

const BoxContent = ({ children, ...props }) => {
  switch (props.box.type) {
    case 'weather':
      return <WeatherBox {...props} />;
    case 'user-presence':
      return <AtHomeBox {...props} />;
    case 'camera':
      return <CameraBox {...props} />;
    case 'temperature-in-room':
      return <RoomTemperatureBox {...props} />;
    case 'humidity-in-room':
      return <RoomHumidityBox {...props} />;
    case 'devices-in-room':
      return <DevicesInRoomsBox {...props} />;
    case 'devices':
      return <DevicesBox {...props} />;
    case 'chart':
      return <ChartBox {...props} />;
    case 'ecowatt':
      return <EcowattBox {...props} />;
    case 'clock':
      return <ClockBox {...props} />;
    case 'scene':
      return <SceneBox {...props} />;
    case 'alarm':
      return <AlarmBox {...props} />;
    case 'music':
      return <MusicBox {...props} />;
    case 'edf-tempo':
      return <EdfTempoBox {...props} />;
    case 'gauge':
      return <GaugeBox {...props} />;
    case 'energy-consumption':
      return <EnergyConsumptionBox {...props} />;
    case 'energy-price':
      return <EnergyPriceBox {...props} />;
    case 'voice-assistant':
      return <VoiceAssistantBox {...props} />;
    case 'link':
      return <LinkBox {...props} />;
    case 'photo':
      return <PhotoBox {...props} />;
    case 'sun':
      return <SunBox {...props} />;
    case 'chips':
      return <ChipsBox {...props} />;
    case 'house-view':
      return <HouseViewBox {...props} />;
    case 'actions':
      return <ActionsBox {...props} />;
    case 'external-widget':
      return <ExternalWidgetBox {...props} />;
    case 'thermostat':
      return <ThermostatBox {...props} />;
  }
};

// Every widget renders user-supplied configuration, and a dashboard is a wall
// of them: a single widget throwing while it renders used to take the whole
// app down with it (see ErrorBoundary), including the editor the user needs
// to fix that very widget. Contain it to its own card instead — the rest of
// the dashboard keeps working, and re-picking a type clears the message.
const Box = ({ children, ...props }) => (
  <ErrorBoundary resetKey={props.box.type} compact>
    <BoxContent {...props} />
  </ErrorBoundary>
);

export default Box;
